import React from "react";

import { Div } from "Common/HTML";
import { RadioGroup } from "Theme/RadioGroup";

type InputProps = {
  onChange?: (arg0: Event) => void;
  value?: string;
  name?: string;
};

type Props = {
  disabled?: boolean;
  inline?: boolean;
  options?: Record<string, React.ReactNode> | Array<[string, React.ReactNode]>;
  id: string;
  name: string;
  meta?: unknown;
  input?: InputProps;
  children?: React.ReactNode;
};

const SIFormRadioGroup = ({ disabled = false, inline, options = { Yes: "Yes", No: "No" }, id, name, meta: _meta, input = {}, ...rest }: Props) => {
  const { value, onChange, name: inputName, ...inputRest } = input;
  return (
    <Div className="SIFormRadioGroup">
      <RadioGroup
        id={id}
        name={inputName || name}
        inline={inline}
        disabled={disabled}
        options={options}
        value={value}
        onChange={onChange}
        {...inputRest}
        {...rest}
      />
    </Div>
  );
};

export default SIFormRadioGroup;
